export const _en = {
    addButton: {
        label: "Add plane type"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add plane type"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Type avion"
    },
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    modal: {
        add: {
            title: "Ajout d'un type avion"
        }
    }
};